import { ApiResponse, fetcher } from './base-api';
import { CategoryDto } from './types/pricing.type';

export const getPricingList = async (): Promise<ApiResponse<CategoryDto[]>> => {
  return fetcher<CategoryDto[]>('/pricing');
};

export const getUnlimited2WeeksMaxDiscountAmount = async (): Promise<
  ApiResponse<number>
> => {
  return fetcher<number>('/pricing/unlimited-2weeks-max-discount-amount');
};
